/*
 * A PERSON'S FACE — their Google photo, else their initial on a colour of their own (Jay, 2026-10-27: "can we show our
 * Google avatar in Catchy chat and HEVN Portal?"). The photo address is kept at each Google sign-in
 * (rememberGoogleAvatar in server.js); a person who has only used a password, or whose photo fails to load, gets the
 * initial — the same look Google itself gives an account without a photo.
 *
 * `no-referrer`: Google's image host may refuse a request that names the page it came from.
 */
import React, { useState } from 'react';

const COLOURS = ['#E8710A', '#1A73E8', '#188038', '#A142F4', '#D93025', '#12B5CB', '#C5221F', '#5F6368'];
const colourOf = (name) => COLOURS[[...String(name || '?')].reduce((a, c) => (a * 31 + c.charCodeAt(0)) >>> 0, 7) % COLOURS.length];

export default function UserAvatar({ url, name, size = 28, className = '' }) {
  const [broken, setBroken] = useState(false);
  const style = { width: size, height: size, fontSize: Math.round(size * 0.46) };
  if (url && !broken) {
    return <img className={`user-avatar ${className}`.trim()} src={url} alt="" style={style} referrerPolicy="no-referrer" onError={() => setBroken(true)} />;
  }
  const initial = [...String(name || '?').trim()][0]?.toUpperCase() || '?';
  return <span className={`user-avatar user-avatar-initial ${className}`.trim()} style={{ ...style, background: colourOf(name) }} aria-hidden="true">{initial}</span>;
}
